// ======================================================================
// File Name       : ServiceLoginType
//
// Copyright(C) 2017 NIPPON TELEGRAPH AND TELEPHONE EAST CORPORATION All
// Rights Reserved.
//
// This source code or any portion thereof must not be
// reproduced or used in any manner whatsoever.
// ======================================================================

import React from 'react';
import { Form, Col } from 'react-bootstrap';

class ServiceLoginType extends React.Component {
  constructor() {
    super();
    this.selected = '0';

    this.handleChange = this.handleChange.bind(this);
  }
  handleChange(event) {
    const value = event.target.value;
    this.selected = value;
    this.props.onHandleChangeServiceType(event);
  }
  render() {
    return (
      <Col sm={12}>
        <h1 className="margin-bottom-20">サービスの切り替え</h1>
        <Form className='form-horizontal'>
          <Form.Group className="form-info padding-left-15">
            <Col sm={4}>
              <Form.Check
                type='radio'
                className="padding-top-5"
                name="serviceType"
                id="serviceType-0"
                inline
                value={0}
                onChange={this.handleChange}
                checked={this.selected === '0'}
                label='通常サービス'></Form.Check>
            </Col>
            <Col sm={4}>
              <Form.Check
                type='radio'
                className="padding-top-5"
                name="serviceType"
                id="serviceType-2"
                inline
                value={2}
                onChange={this.handleChange}
                checked={this.selected === '2'}
                label='コンテンツ配信サービス'></Form.Check>
            </Col>
          </Form.Group>
        </Form>
      </Col>
    );
  }
}

export default ServiceLoginType;
